module.exports = __webpack_public_path__ + "img/gamepad.2872c299.svg";